// Freestar placement names, as configured in Freestar's dashboard (FAD). Freestar
// has no Thor placements, so Thor uses these prod ones too.
//
// Each sticky footer placement serves its own GAM unit, so the ads team can target
// each page and owner type separately.
// GAM unit: Display_AthleteTimeline_Mobile
export const ATHLETE_TIMELINE_STICKY_FOOTER_PLACEMENT = 'hudl-com_sticky_footer_AthleteTimeline';
// GAM unit: Display_VideoPage_Mobile
export const VIDEO_PAGE_STICKY_FOOTER_PLACEMENT = 'hudl-com_sticky_footer_VideoPage';
// GAM unit: Display_TeamVideoPage_Mobile
export const TEAM_VIDEO_PAGE_STICKY_FOOTER_PLACEMENT = 'hudl-com_sticky_footer_TeamVideoPage';
// GAM unit: Display_VideoPageTest
export const VIDEO_PAGE_SIDEBAR_PLACEMENT = 'hudl-com_Display_VideoPageTest';
